import { get, del, post, put, patch } from "@utils/axios";

const api = "tenants";

export const getAllDataReq = (payload) => {
  return get(`${api}`)
};

export const createDataReq = (payload) => {
  return post(`${api}?`, payload);
};

export const updateDataReq = (payload) => {
  return put(`${api}/${payload.id}`, payload);
};

export const deleteDataReq = (id) => {
  return del(`${api}/${id}`);
};

export const seedTenants = (uuid) => {
  return post(`${api}/seed`, { uuid });
}

export const updateSaasStatus = (uuid, status) => {
  return patch(`${api}/${uuid}`, { active: status });
}
